import { createSlice } from '@reduxjs/toolkit';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
var initialState = {
    currentUser: null,
    adminUser: false,
    proUser: false,
    mobileBrowser: false,
    tabletBrowser: false,
    displayMetric: false,
    languageRegionCode: LanguageRegionCode.English,
    primaryAlgoliaIndexId: ''
};
export var contextSlice = createSlice({
    name: 'context',
    initialState: initialState,
    reducers: {
        setContext: function (state, action) {
            state = action.payload;
            return state;
        }
    }
});
export var setContext = contextSlice.actions.setContext;
export default contextSlice.reducer;
//# sourceMappingURL=index.js.map